export enum E_LocalStorageKey {
  userDeviceId = 'userDeviceId',
  userCurGenerateQuestionId = 'userCurGenerateQuestionId',
  userCurGenerateQuestionPicUrl = 'userCurGenerateQuestionPicUrl',
  userCurGenerateQuestionContent = 'userCurGenerateQuestionContent',
  userWaittingForSubmitQuestionQueue = 'userWaittingForSubmitQuestionQueue',
}

export class LocalStorageUtil {
  public static getLocalStorage(key: E_LocalStorageKey) {
    if (typeof window === 'undefined') {
      return null;
    }
    return localStorage.getItem(key);
  }

  public static setLocalStorage(key: E_LocalStorageKey, value: string) {
    if (typeof window === 'undefined') {
      return null;
    }
    localStorage.setItem(key, value);
  }

  public static removeLocalStorage(key: E_LocalStorageKey) {
    if (typeof window === 'undefined') {
      return null;
    }
    localStorage.removeItem(key);
  }
}
